// ✅ FILE: src/pages/CorporateGovernancePage.js

import React from 'react';
import CorporateGovernance from '../components/corporate-governance';

const CorporateGovernancePage = () => {
  return (
    <div className="corporate-governance-page">
      <CorporateGovernance />
    </div>
  );
};

export default CorporateGovernancePage;
